import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/sass/app.scss'
import { createProvider } from './vue-apollo'
import vSelect from 'vue-select'
import IconChevronBottom from '@/assets/icons/icon-chevron_bottom.svg'
import InputVue from '@/components/fields/InputVue.vue'
import CheckboxVue from '@/components/fields/CheckboxVue.vue'
import TextArea from '@/components/fields/TextArea.vue'
import ImageInput from '@/components/fields/ImageInput.vue'
import DateInput from '@/components/fields/DateInput.vue'
import AudioInput from '@/components/fields/AudioInput.vue'
import MediumEditor from '@/components/fields/MediumEditor.vue'
import FormRow from '@/components/FormRow.vue'
import './vee-validate'

import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

Bugsnag.start({
  apiKey: process.env.VUE_APP_BUGSNAG_APP_FRONTEND,
  plugins: [new BugsnagPluginVue()],
})

Vue.config.productionTip = false

vSelect.props.components.default = () => ({
  OpenIndicator: {
    render: createElement =>
      createElement(
        'i',
        {
          class: 'select-arrow icon-checvron_bottom',
        },
        [createElement(IconChevronBottom)],
      ),
  },
})

Vue.component('v-select', vSelect)
Vue.component('v-input', InputVue)
Vue.component('v-check', CheckboxVue)
Vue.component('v-textarea', TextArea)
Vue.component('v-image-input', ImageInput)
Vue.component('v-date', DateInput)
Vue.component('v-audio', AudioInput)
Vue.component('v-medium-editor', MediumEditor)
Vue.component('FormRow', FormRow)

Vue.component('v-style', {
  render: function(createElement) {
    return createElement('style', this.$slots.default)
  },
})

new Vue({
  router,
  store,
  apolloProvider: createProvider(),
  render: h => h(App),
}).$mount('#visual-podcasts-app')
